<ng-container *ngIf="isQuizLoading ; else pageContent">
	<div class="app-spinner">
		<mat-spinner diameter="60"></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>

<div class="quiz-wrapper" [formGroup]="quizForm" *ngIf="quizForm">
  <!-- Main Quiz Container -->
  <div class="quiz-container">
    <div class="quiz-header">
      <h1  matTooltip="{{quizData?.quiz_name || resumeData.quiz_name}}">
        <img src="assets/images/student_card_2.svg" alt="quiz icon" class="titlelogo me-2" />
        <span class="truncate">{{ quizData?.quiz_name || resumeData.quiz_name}}</span>
      </h1>
      <div class="header-right">
        <div class="quiz-timer">
          Time Limit: <span class="timer">{{ formattedTime }}</span>
        </div>
        <span class="question-count">
          Question: {{ currentQuestion + 1 }}/{{ questions.length }}
        </span>
      </div>
    </div>

    <!-- Progress -->
    <div class="progress-section">
      <div class="progress-bar">
        <div class="progress" [style.width]="progressPercentage + '%'"></div>
      </div>
    </div>

    <!-- Question Section -->
    <div class="quiz-content" *ngIf="questions.length > 0 && currentQuestion < questions.length">
      <!-- Question Header -->
      <div class="question-text">
        Q{{ currentQuestion + 1 }}:
        <app-question-blocks
          [blocks]="questions[currentQuestion].question_blocks || null"
          [content]="questions[currentQuestion].question_text"
          [diagrams]="questions[currentQuestion].diagrams || []">
        </app-question-blocks>
      </div>
      <p class="points">{{ questions[currentQuestion].marks }} Points</p>

      <!-- MCQ -->
      <div class="question-section" *ngIf="questions[currentQuestion].question_type === 'MCQ'">
        <div class="options" [formGroup]="getQuestionForm(currentQuestion)">
          <label class="custom-radio" *ngFor="let option of questions[currentQuestion].options">
            <input type="radio" formControlName="answer" [value]="option.text" (change)="onOptionSelect(option.text)"/>
            <span class="radio-check"></span>
            <app-question-blocks
              [blocks]="option.blocks"
              [content]="option.text"
              [diagrams]="[]">
            </app-question-blocks>
            <img
              *ngIf="option.image_url && (!option.blocks || option.blocks.length === 0)"
              [src]="option.image_url"
              [alt]="option.text || 'option image'"
              class="option-diagram" />
          </label>
        </div>
      </div>

      <!-- True/False -->
      <div class="question-section" *ngIf="questions[currentQuestion].question_type === 'TRUE_FALSE'">
        <div class="options" [formGroup]="getQuestionForm(currentQuestion)">
          <label class="custom-radio">
            <input type="radio" formControlName="answer" value="True" />
            <span class="radio-check"></span>
           <app-math-latex [content]="'True'"></app-math-latex>
          </label>
          <label class="custom-radio">
            <input type="radio" formControlName="answer" value="False" />
            <span class="radio-check"></span>
            <app-math-latex [content]="'False'"></app-math-latex>
          </label>
        </div>
      </div>

      <!-- Open-Ended -->
      <div class="question-section" *ngIf="questions[currentQuestion].question_type === 'OPEN_ENDED'">
        <div class="options" [formGroup]="getQuestionForm(currentQuestion)">
          <textarea formControlName="answer" class="form-control" rows="4"
            placeholder="Type your answer here..."></textarea>
        </div>
      </div>
    </div>

    <!-- Navigation outside the question box -->
    <div class="navigation">
      <div class="left-buttons">
        <button class="nav-btn previous" *ngIf="currentQuestion > 0" (click)="prevQuestion()">
          <img src="assets/images/keyboard_arrow_left.svg" alt="previous" class="btn-icon me-2" />
          Previous
        </button>
      </div>

      <div class="right-buttons">
        <button class="nav-btn" *ngIf="currentQuestion < questions.length - 1" (click)="nextQuestion()">
          Next
          <img src="assets/images/chevron_forward.svg" alt="next" class="btn-icon ms-2" />
        </button>
        <button class="nav-btn submit" *ngIf="currentQuestion === questions.length - 1" (click)="submitQuiz()"
              [disabled]="!attemptId || (!quizData && !resumeData) || !quizForm.valid || quizSubmitted">
          <img src="assets/images/trophy.svg" alt="submit" class="btn-icon me-2" />
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
</ng-template>
<div class="loader-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" diameter="70" color="primary"></mat-progress-spinner>
  <p>Submitting and evaluating your answers... This may take a few seconds.</p>
</div>